import React from 'react';

import './style.scss';

const PagerPrevNext = ({ currentPage, totalPages, setCurrentPage }) => {
  const previousPage = (currentPage !== 0 ? currentPage - 1 : false);
  const nextPage = (currentPage !== (totalPages - 1) ? currentPage + 1 : false);


  return (
    totalPages > 1 ? (
      <div className="PagerPrevNext">
        {previousPage !== false ? (
          <div
            className="PagerPrevNext__button PagerPrevNext__icon PagerPrevNext__icon--left"
            onClick={(e) => {
              setCurrentPage(previousPage);
              window.scrollTo(0, 0);
            }}>
            <i className="icon-before icon-caret icon-variant-2 icon-reverse" />
            <span>Vorige</span>
          </div>
        ) : null}
        <div className="flex-fill" />
        {nextPage !== false ? (
          <div
            className="PagerPrevNext__button PagerPrevNext__icon"
            onClick={(e) => {
              setCurrentPage(nextPage);
              window.scrollTo(0, 0);
            }}>
            <span>Volgende</span>
            <i className="icon-before icon-caret icon-variant-2" />
          </div>
        ) : null}
      </div>
    ) : null
  );

};
export default PagerPrevNext;
